import React, { useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { SupplierExportToolbar } from "./SupplierExportToolbar";
import { SECTIONS } from "./sheetModel";

// Split-order dispatch: send only the checked rows to one supplier as an unbranded PDF.
export const DispatchPanel = ({ sheet, suppliers, setSuppliers, selectedIds, onDispatched, canDispatch, dirty }) => {
  const [notes, setNotes] = useState("");
  const ids = [...selectedIds];
  const counts = SECTIONS.map(s => ({ ...s, n: (sheet.sections[s.key] || []).filter(r => selectedIds.has(r.row_id)).length })).filter(s => s.n);
  return (
    <div className="relative z-50 rounded-xl border bg-white p-4 space-y-3" data-testid="dispatch-panel">
      <div>
        <h3 className="font-semibold text-slate-900" style={{ fontFamily: "Manrope, sans-serif" }}>Dispatch to supplier</h3>
        <p className="text-xs text-slate-500">Unbranded PDF + editable Excel · P.O &quot;{sheet.customer_last_name || "Customer"}&quot; · no pricing</p>
      </div>
      <div className="text-sm rounded-lg bg-slate-50 border p-2" data-testid="dispatch-selection-summary">
        {ids.length ? <span><b>{ids.length}</b> row{ids.length > 1 ? "s" : ""} selected: {counts.map(c => `${c.n} ${c.short.toLowerCase()}`).join(", ")}</span>
          : <span className="text-slate-400">Tick rows in the grid (any tab) to build this shipment</span>}
      </div>
      <div>
        <Label className="text-xs">Note to supplier (optional)</Label>
        <Textarea rows={2} className="mt-1 text-sm" value={notes} onChange={e => setNotes(e.target.value)} placeholder="Edge profile, grain direction, delivery date…" data-testid="dispatch-notes" />
      </div>
      <SupplierExportToolbar sheet={sheet} suppliers={suppliers} setSuppliers={setSuppliers} selectedIds={selectedIds} canDispatch={canDispatch} dirty={dirty} notes={notes}
        onDispatched={(updated) => { onDispatched(updated); setNotes(""); }} compact />
    </div>
  );
};
